module.exports = __webpack_public_path__ + "img/BACKUP.c4567b34.svg";